// https://toddmotto.com/ditch-the-array-foreach-call-nodelist-hack/
export function forEach (arr, callback, scope) {
  // CUSTOM
	// Check if the array is not null or undefined
  if (!arr) return;
  
    for (var i = 0, l = arr.length; i < l; i++) {
      callback.call(scope, arr[i], i);
    }
  }